import Immutable from 'immutable';

import type { ActionType } from 'sharedreact/actions/generic/actions';
import SortOrder from 'sharedreact/data/SortOrder';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';
import type ItemsState from 'sharedreact/stores/generic/ItemsState';
import ItemsStore from 'sharedreact/stores/generic/ItemsStore';
import { translate } from 'sharedreact/utils/LanguageSupport';

import ViewSessionsActions from 'workspaces/launcher/actions/ViewSessionsActions';
import ViewSessionsConstants from 'workspaces/launcher/constants/ViewSessionsConstants';
import ViewSession from 'workspaces/launcher/data/ViewSession';

const ExtraDataContent: {
  maxSessions: number
} = {
  maxSessions: -1
};

class ExtraData extends Immutable.Record(ExtraDataContent) {
}

class ViewSessionsStore extends ItemsStore<ViewSession, ExtraData> {
  constructor () {
    super(AppDispatcher, ViewSessionsActions, ViewSessionsConstants);
  }

  override getInitialState (): ItemsState<ViewSession, ExtraData> {
    return super.getInitialState().set('extraData', new ExtraData());
  }

  getInitialSortOrder (): SortOrder {
    return new SortOrder({keyword: 'started', ascending: false});
  }

  getSecondarySortKeyword (): string {
    return 'started';
  }

  getValue (item: ViewSession, itemKey: string): any {
    if (itemKey === 'documents') {
      return item.documents?.join();
    } else if (itemKey === 'viewengine') {
      return translate('launcher.admin.viewsessions.viewengine.' + item.viewEngine.toLowerCase())
    } else if (itemKey === 'started') {
      return item.startedDate;
    } else if (itemKey === 'remotehost') {
      return item.remoteHost;
    } else {
      return super.getValue(item, itemKey);
    }
  }

  getMaxSessions (): number {
    return this.getState().extraData!.maxSessions;
  }

  override reduce (state: ItemsState<ViewSession, ExtraData>, action: ActionType): ItemsState<ViewSession, ExtraData> {
    switch (action.actionType) {
      case ViewSessionsConstants.UPDATE_MAXSESSIONS: {
        return state
          .set('extraData', state.extraData!
            .set('maxSessions', action.maxSessions)
        );
      }
    }
    return super.reduce(state, action);
  }
}

export default new ViewSessionsStore();
